import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './dashboard.action';
import { Data } from './dashboard.model';

export interface DashboardRecordsState {
    listData: Data;
    loading: boolean;
    error: any;
}

export const initialState: DashboardRecordsState = {
    listData: null,
    loading: false,
    error: null
};


export const DashboardRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData }) => {
        return { ...state, listData, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(resetState, () => initialState)  // Reset action handler
    
);